'use strict';

// The gulp bundler will populate this with a unique value
let versionKey = '@@versionKey';

/**
 * @ngdoc overview
 * @name cimerFrontEndApp
 * @description
 * # cimerFrontEndApp
 *
 * Main module of the application.
 */
angular
  .module('cimerFrontEndApp', [
    'ngAnimate',
    'ngCookies',
    'ngResource',
    'ngRoute',
    'ngSanitize',
    'ngTouch',
    'ui.bootstrap',
    'ui.scrollpoint',
    'ngFileUpload',
    'angularUtils.directives.dirPagination',
    'ui.sortable',
    'angularjs-dropdown-multiselect',
    'duScroll',
    'ui.tinymce'
  ])
  .config(['$routeProvider', '$httpProvider','$locationProvider', function ($routeProvider, $httpProvider, $locationProvider) {

      // If the gulp bundler didn't run, fall back to today's date
      if (versionKey.indexOf('@@') > -1) {
          versionKey = new Date().toISOString().slice(0, 10).replace(/-/g, '');
      }

      $locationProvider.hashPrefix('');

      $routeProvider
          .when('/', {
              templateUrl: '/Content/Templates/account/login.html' + '?v=' + versionKey,
              controller: 'LoginCtrl',
              title: 'CIMER Portal - Login',
              curNavLink: 'login'
          })
        .when('/login', {
            templateUrl: '/Content/Templates/account/login.html' + '?v=' + versionKey,
            controller: 'LoginCtrl',
            title: 'CIMER Portal - Login',
            curNavLink: 'login'
        })
        .when('/register', {
            templateUrl: '/Content/Templates/account/register.html' + '?v=' + versionKey,
            controller: 'RegisterCtrl', 
            title: 'Register - CIMER Portal',
            curNavLink: ''
        })
        .when('/sessionExpired', {
            templateUrl: '/Content/Templates/account/sessionExpired.html' + '?v=' + versionKey,
            controller: 'LoginCtrl',
            title: 'Session Expired - CIMER Portal',
            curNavLink: ''
        })
        .when('/error', {
            templateUrl: '/Content/Templates/account/error.html' + '?v=' + versionKey,
            title: 'Error - CIMER Portal',
            curNavLink: ''
        })

        //CURRICULA
        .when('/training-curricula', {
            templateUrl: '/Content/Templates/bookbag/training-curricula.html' + '?v=' + versionKey,
            controller: 'TrainingCurriculaCtrl',
            title: 'Training Curricula - CIMER Portal',
            curNavLink: 'trainingCurricula'
        })

        //RESOURCES

        .when('/completeCurricula', {
            templateUrl: '/Content/Templates/public/completeMentorCurricula.html' + '?v=' + versionKey,
            title: 'Complete Mentor Curricula - CIMER Portal',
            curNavLink: 'trainingCurricula'
        })
        .when('/completeCurricula/mentor', {
            templateUrl: '/Content/Templates/public/completeMentorCurricula.html' + '?v=' + versionKey,
            title: 'Complete Entering Mentoring Curricula - CIMER Portal',
            curNavLink: 'trainingCurricula'
        })
        .when('/completeCurricula/mentee', {
            templateUrl: '/Content/Templates/public/completeMenteeCurricula.html' + '?v=' + versionKey,
            title: 'Complete Entering Research Curricula - CIMER Portal',
            curNavLink: 'trainingCurricula'
        })
        .when('/completeCurricula/mentoringup', {
            templateUrl: '/Content/Templates/public/completeMentoringUpCurricula.html' + '?v=' + versionKey,
            title: 'Complete Mentoring Up Curricula - CIMER Portal',
            curNavLink: 'trainingCurricula'
        })
        .when('/customMentorCurricula', {
            templateUrl: '/Content/Templates/public/customMentorCurricula.html' + '?v=' + versionKey,
            controller: 'CustomCurriculaCtrl',
            title: 'Custom Entering Mentoring Curricula - CIMER Portal',
            curNavLink: 'trainingCurricula'
        })
        .when('/customMenteeCurricula', {
            templateUrl: '/Content/Templates/public/customMenteeCurricula.html' + '?v=' + versionKey,
            controller: 'CustomCurriculaCtrl',
            title: 'Custom Entering Research Curricula - CIMER Portal',
            curNavLink: 'trainingCurricula'
        })
        .when('/director', {
            templateUrl: '/Content/Templates/director/director.html' + '?v=' + versionKey,
            controller: 'DirectorCtrl',
            title: 'Survey Management - CIMER Portal',
            curNavLink: 'mySurveys'
        })
        .when('/director/alternate', {
            templateUrl: '/Content/Templates/director/directorAlternate.html' + '?v=' + versionKey,
            controller: 'DirectorAlternateCtrl',
            title: 'Additional Survey Admin - CIMER Portal',
            curNavLink: 'mySurveys'
        })
        .when('/director/upload/:grantID?', {
            templateUrl: '/Content/Templates/director/directorUserUpload.html' + '?v=' + versionKey,
            controller: 'DirectorUserUploadCtrl',
            title: 'Upload Users - CIMER Portal',
            resolve: {
                authorized: ['$route', 'Session', function ($route, Session) {
                    return Session.userCanAccessGrant($route.current.params.grantID);
                }]
            },
            curNavLink: 'mySurveys'
        })
        .when('/myProfile', {
            templateUrl: '/Content/Templates/profile/myProfile.html' + '?v=' + versionKey,
            controller: 'MyProfileCtrl',
            title: 'My User Profile - CIMER Portal',
            curNavLink: 'myUserProfile'
        })
        .when('/forgotPassword', {
            templateUrl: '/Content/Templates/account/forgotPassword.html' + '?v=' + versionKey,
            controller: 'ForgotPasswordCtrl',
            title: 'Reset Password - CIMER Portal',
            curNavLink: ''
        })
        .when('/resetPassword', {
            templateUrl: '/Content/Templates/account/resetPassword.html' + '?v=' + versionKey,
            controller: 'ResetPasswordCtrl',
            title: 'Reset Password - CIMER Portal',
            curNavLink: ''
        })
          .when('/dashboard', {
              templateUrl: '/Content/Templates/bookbag/dashboard.html' + '?v=' + versionKey,
              controller: 'DashboardCtrl',
              title: 'Dashboard - CIMER Portal',
              curNavLink: 'home'
          })
        .when('/mySurveys', {
            templateUrl: '/Content/Templates/survey/mySurveys.html' + '?v=' + versionKey,
            controller: 'MySurveysCtrl',
            title: 'My Surveys - CIMER Portal',
            curNavLink: 'mySurveys'
        })
        .when('/survey', {
            templateUrl: '/Content/Templates/survey/survey.html' + '?v=' + versionKey,
            controller: 'SurveyCtrl',
            title: 'Survey - CIMER Portal',
            curNavLink: ''
        })
        .when('/surveypreview/:surveyId?', {
            templateUrl: '/Content/Templates/survey/surveypreview.html' + '?v=' + versionKey,
            controller: 'SurveyPreviewCtrl',
            title: 'Survey Preview - CIMER Portal',
            resolve: {
                // Authorize privileges (director or admin) for the survey
                authorized: ['$route', 'Session', function ($route, Session) {
                    return Session.userCanAccessSurvey($route.current.params.surveyId);
                }]
            },
            curNavLink: 'mySurveys'
        })
        .when('/assignSurvey/:GrantID/:SurveyID?', {
            templateUrl: '/Content/Templates/director/assignSurvey.html' + '?v=' + versionKey,
            controller: 'AssignSurveyCtrl',
            title: 'Assign Survey - CIMER Portal',
            resolve: {
                authorized: ['$route', 'Session', function ($route, Session) {
                    // Authorize director privileges for the grant 
                    // (director privileges are on the grant level, so don't need to do any further validation at the survey level)
                    return Session.userCanAccessGrant($route.current.params.GrantID);
                }]
            },
            curNavLink: 'mySurveys'
        })
        .when('/customSurvey/:id', {
            templateUrl: '/Content/Templates/survey/customSurvey.html' + '?v=' + versionKey,
            controller: 'CustomSurveyCtrl',
            title: 'Custom Survey - CIMER Portal',
            resolve: {
                // Authorize director privileges for the grant (id in the route is the grant)
                authorized: ['$route', 'Session', function ($route, Session) {
                    return Session.userCanAccessGrant($route.current.params.id);
                }]
            },
            curNavLink: 'mySurveys'
        })
        .when('/createMentorshipSurvey', {
            templateUrl: '/Content/Templates/createMentorshipSurvey.html' + '?v=' + versionKey,
            controller: 'CreateMentorshipSurveyCtrl',
            title: 'Create Mentorship Survey - CIMER Portal',
            curNavLink: 'mySurveys'
        })
          // Admin //
        .when('/uploadDirectors', {
            templateUrl: '/Content/Templates/admin/uploadDirectors.html' + '?v=' + versionKey,
            controller: 'UploadDirectorCtrl',
            title: 'Create New Event - CIMER Portal',
            curNavLink: 'surveyAdmin'
        })
        .when('/uploadDocument', {
            templateUrl: '/Content/Templates/admin/uploadDocument.html' + '?v=' + versionKey,
            controller: 'UploadDocumentCtrl',
            title: 'Upload Document - CIMER Portal',
            curNavLink: 'curriculaAdmin'
        })
        .when('/editDocument/:documentID', {
            templateUrl: '/Content/Templates/admin/uploadDocument.html' + '?v=' + versionKey,
            controller: 'UploadDocumentCtrl',
            title: 'Edit Document - CIMER Portal',
            curNavLink: 'curriculaAdmin'
        })
          .when('/userSearch', {
              templateUrl: '/Content/Templates/admin/userSearch.html' + '?v=' + versionKey,
              controller: 'UserSearchCtrl',
              title: 'User Search - CIMER Portal',
              curNavLink: 'surveyAdmin'
          })

          .when('/baseSurvey/:divisionID',
          {
              templateUrl: '/Content/Templates/survey/baseSurvey.html' + '?v=' + versionKey,
              controller: 'BaseSurveyCtrl',
              title: 'Create/Edit Base Survey - CIMER Portal',
              curNavLink: 'surveyAdmin'
          })
          .when('/curatedQuestions',
          {
              templateUrl: '/Content/Templates/survey/curatedQuestions.html' + '?v=' + versionKey,
              controller: 'CuratedQuestionsCtrl',
              title: 'Curated Questions - CIMER Portal',
              curNavLink: 'surveyAdmin'
          })
        .when('/searchSurvey', {
            templateUrl: '/Content/Templates/admin/surveySearch.html' + '?v=' + versionKey,
            controller: 'SearchSurveyCtrl',
            title: 'Survey Search - CIMER Portal',
            curNavLink: 'surveyAdmin'
        })
          .when('/grantSearch', {
              templateUrl: '/Content/Templates/admin/grantSearch.html' + '?v=' + versionKey,
              controller: 'GrantSearchCtrl',
              title: 'Event Search - CIMER Portal',
              curNavLink: 'surveyAdmin'
          })
          .when('/downloadEventDetails', {
              templateUrl: '/Content/Templates/admin/downloadGrantDetails.html' + '?v=' + versionKey,
              controller: 'DownloadGrantDetailsCtrl',
              title: 'Download Event Details - CIMER Portal',
              curNavLink: 'surveyAdmin'
          })
          // Reports //
        .when('/report/:id/:isBase?', {
            templateUrl: '/Content/Templates/survey/report.html' + '?v=' + versionKey,
            controller: 'ReportingCtrl',
            title: 'Survey Report - CIMER Portal',
            resolve: {
                // Authorize privileges (director or admin) for the survey
                authorized: ['$route', 'Session', function ($route, Session) {
                    return Session.userCanAccessSurvey($route.current.params.id);
                }]
            },
            curNavLink: 'surveyAdmin'
        })
        .when('/reportDetails', {
            templateUrl: '/Content/Templates/survey/reportDetail.html' + '?v=' + versionKey,
            controller: 'ReportQuestionDetailCtrl',
            title: 'Report Details - CIMER Portal',
            curNavLink: 'mySurveys'
        })

          // Custom Curricula //
        .when('/searchCustomCurricula/:roleId?',
          {
              templateUrl: '/Content/Templates/bookbag/searchCurricula.html' + '?v=' + versionKey,
              controller: 'SearchCurriculaCtrl',
              title: 'Search Custom Curricula - CIMER Portal',
              curNavLink: 'myCurricula'
          })

        .when('/myCurricula', {
            templateUrl: '/Content/Templates/bookbag/myCurricula.html' + '?v=' + versionKey,
            controller: 'MyCurriculaCtrl',
            title: 'My Curricula - CIMER Portal',
            curNavLink: 'myCurricula'
        })

        .when('/documentList', {
            templateUrl: '/Content/Templates/bookbag/documentList.html' + '?v=' + versionKey,
            controller: 'DocumentListCtrl',
            title: 'Document List - CIMER Portal',
            curNavLink: 'curriculaAdmin'
        })

        .when('/documentsByTag', {
            templateUrl: '/Content/Templates/bookbag/documentsByTag.html' + '?v=' + versionKey,
            controller: 'DocumentsByTagCtrl',
            title: 'Documents by Tag - CIMER Portal',
            curNavLink: 'curriculaAdmin'

        })
        .when('/baseSurveys', {
            templateUrl: '/Content/Templates/admin/baseSurveys.html' + '?v=' + versionKey,
            controller: 'BaseSurveysCtrl',
            title: 'Survey Admin - CIMER Portal',
            curNavLink: 'surveyAdmin'
        })

      //TESTING only
      .when('/testSurvey/:id', {
          templateUrl: '/Content/Templates/survey/testSurvey.html' + '?v=' + versionKey,
          controller: 'TestSurveyCtrl',
          curNavLink: ''
      })
      .when('/searchbookBags', {
          templateUrl: '/Content/Templates/bookbag/searchBookBags.html' + '?v=' + versionKey,
          controller: 'SearchBookBagsCtrl',
          curNavLink: ''
      })
      .otherwise({
          redirectTo: '/'
      });

      //add an interceptor to catch timeouts and redirect to session expired page
      $httpProvider.interceptors.push('UnauthorizedInterceptor');

  }]);

angular.module('cimerFrontEndApp').run(['$rootScope', '$route', '$timeout', function ($rootScope, $route, $timeout) {

    var history; // stores uri of last page viewed - Used to track if we should set focus to main H1
   
    $rootScope.$on("$routeChangeSuccess", function (event, current, previous) {

        // Test for current route
        if (current.$$route) {          
            // set page title to current route record
            $rootScope.title = current.$$route.title;

            if (current.$$route.curNavLink !== undefined) {
                $rootScope.curNavLink = current.$$route.curNavLink;
            }

        }

        // When navigating between pages track the last page we were on
        // to know if we should be setting focus on the h1 on view update
        if (previous) {
            if (previous.$$route) {
                history = previous.$$route.originalPath;
            }
        }

    });

    $rootScope.$on('$viewContentLoaded', function () {

        // Once the template loads set focus to the h1 to manage focus
        // if there is no history do not adjust focus this is the first page the user is seeing
        if (history) {
            if ($('h1').length) {
                // Default - set page focus to h1
                $timeout(function () {
                    $('h1').attr("tabIndex", -1).focus();
                }, 0);               
            }
            else
            {
                $timeout(function () {
                    $('#main').focus();
                }, 0);     
            }          
        }
    });

}]);

angular.module('cimerFrontEndApp').factory('UnauthorizedInterceptor', ['$injector', function ($injector) {
    var interceptor = {
        responseError: function (response) {
            //session has expired
            if (response.status === 401) {
                //manually inject $location and Session services to prevent circular dependency
                var Session = $injector.get('Session');
                var $location = $injector.get('$location');
                //clear session object
                Session.clearSessionObject();
                $location.url('/sessionExpired');
            }
        }
    };

    return interceptor;
}]);